import { z } from 'zod';

export const globalVariableSchema = z.object({
  idGlobalVariable: z.number().default(-1),
  GlobalVariable: z.string().default(''),
  VariableValue: z.string().default(''),
});

export type IGlobalVariable = z.infer<typeof globalVariableSchema>;
